import { FormControl, FormGroup, Validators } from '@angular/forms';

import { ContactForm } from './contact-form';

export class UserForm extends FormGroup<{
  id: FormControl<number | undefined | null>;
  VendorId: FormControl<number | null>;
  CompanyId: FormControl<number | undefined | null>;
  ContactId: FormControl<number | undefined | null>;
  firstName: FormControl<string | undefined>;
  lastName: FormControl<string | undefined>;
  phone: FormControl<string | undefined>;
  extension: FormControl<string | null | undefined>;
  email: FormControl<string | undefined>;
  jobTitle: FormControl<string | undefined | null>;
  UserAccountRoleId: FormControl<number | undefined>;
  allowTexts: FormControl<boolean | undefined>;
  isSuperUser: FormControl<boolean | undefined>;
  canWaive: FormControl<boolean | undefined>;
  sendWeeklyStatusUpdates: FormControl<boolean | undefined>;
  sendDailyStatusUpdates: FormControl<boolean | undefined>;

  Contact: ContactForm;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined, { nonNullable: true }),
      CompanyId: new FormControl<number | null>(null),
      VendorId: new FormControl<number | null>(null),
      ContactId: new FormControl<number | null | undefined>(undefined),
      firstName: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      lastName: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      phone: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      extension: new FormControl<string | null | undefined>({
        value: undefined,
        disabled: false
      }),
      email: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      jobTitle: new FormControl<string | undefined>(undefined),
      UserAccountRoleId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      allowTexts: new FormControl<boolean | undefined>(false, {
        nonNullable: true
      }),
      isSuperUser: new FormControl<boolean | undefined>(false, {
        nonNullable: true
      }),
      canWaive: new FormControl<boolean | undefined>(false, {
        nonNullable: true
      }),
      sendWeeklyStatusUpdates: new FormControl<boolean | undefined>(false, {
        nonNullable: true
      }),
      sendDailyStatusUpdates: new FormControl<boolean | undefined>(false, {
        nonNullable: true
      }),

      Contact: new ContactForm()
    });
  }
}
